import { render, staticRenderFns } from "./createNxOrder.vue?vue&type=template&id=05d7482f&scoped=true"
import script from "./createNxOrder.vue?vue&type=script&lang=js"
export * from "./createNxOrder.vue?vue&type=script&lang=js"
import style0 from "./createNxOrder.vue?vue&type=style&index=0&id=05d7482f&prod&scoped=true&lang=css"
import style1 from "./createNxOrder.vue?vue&type=style&index=1&id=05d7482f&prod&lang=css"
import style2 from "./createNxOrder.vue?vue&type=style&index=2&id=05d7482f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d7482f",
  null
  
)

export default component.exports